interface props {
  message: string;
  noMargin?: boolean;
}
const CheckoutErrMsg: React.FC<props> = ({ message, noMargin }) => {
  return (
    <div className={`alert auth-err w-100 ${noMargin ? "m-0" : "mt-2"}`}>
      {message}
    </div>
  );
};

export default CheckoutErrMsg;
